import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=502a698d&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"
import style0 from "./Goods.vue?vue&type=style&index=0&id=502a698d&prod&scoped=true&lang=css"
import style1 from "./Goods.vue?vue&type=style&index=1&id=502a698d&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502a698d",
  null
  
)

export default component.exports